import React, { useEffect, useState } from "react";
import {
  getAllDashElements,
  getAppId,
  getAllDashPages,
  getRealtimeUsers,
  getVCMS,
  analytics,
  updates,
  logInDetail,
  analyticsByDate,
} from "../../api/api";
import BarCharts from "../graphs/bar";
import CountryPie from "../graphs/countryPie";
import LineCountry from "../graphs/lineGraph";
import Loader from "../loader/loader";

const Home = () => {
  /* eslint-disable no-unused-vars */
  const [dashElements, setDashElements] = useState([]);
  const [dashPages, setDashPages] = useState([]);
  const [realStats, setRealStats] = useState([]);
  const [actUC, setActUC] = useState([]);
  const [actTC, setActTC] = useState([]);
  const [actPC, setActPC] = useState([]);
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState([]);
  const [media, setMedia] = useState([]);
  const [aUpdates, setAUpdates] = useState([]);
  const [fday, setFday] = useState([]);
  const [fmonth, setFmonth] = useState([]);
  const [fyear, setFyear] = useState([]);
  const [tday, setTday] = useState([]);
  const [tmonth, setTmonth] = useState([]);
  const [tyear, setTyear] = useState([]);
  const [number, setNumber] = useState(0);
  const [time, setTime] = useState("");
  const [search, setSearch] = useState(true);
  const [dAnalytics, setDAnalytics] = useState([]);

  /* eslint-disable no-unused-vars */

  const date = () => {
    var day = { day: "numeric" };
    var month = { month: "numeric" };
    var year = { year: "numeric" };
    var Tday = 0 + new Date().toLocaleDateString([], day);
    var Tmonth = 0 + new Date().toLocaleDateString([], month);
    var Tyear = new Date().toLocaleDateString([], year);

    return Tyear + "-" + Tmonth.slice(-2) + "-" + Tday.slice(-2);
  };

  const oneMonth = () => {
    let today = new Date();

    // for(var i =1; i=7;i++)
    // {

    var day = { day: "numeric" };
    var month = { month: "numeric" };
    var year = { year: "numeric" };

    today.setDate(today.getDate() - 1);

    var Fday = 0 + today.toLocaleDateString([], day);
    var Fmonth = 0 + today.toLocaleDateString([], month);
    var Fyear = today.toLocaleDateString([], year);

    return Fyear + "-" + Fmonth.slice(-2) + "-" + Fday.slice(-2);
  };
  // }
  // date();
  // oneMonth();

  useEffect(() => {
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getAllDashElements(getAppId()).then(
        (result) => {
          setDashElements(result?.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const detail = async () => {
      setLoading(true);
      try {
        const result = await analyticsByDate();
        setDAnalytics(result);
      } catch (error) {
        console.error("Error fetching analytics by date:", error);
      } finally {
        setLoading(false);
      }
    };

    const pageDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getAllDashPages(getAppId()).then(
        (result) => {
          setDashPages(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const RealTimeStats = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("runRealScreenReport").then(
        (result) => {
          setRealStats(result?.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const ActiveUserCountry = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("rungraphReport").then(
        (result) => {
          setActUC(result?.data);

          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const ActiveUserTotal = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("rungraphTopReport").then(
        (result) => {
          setActTC(result?.data);

          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const ActivePageTotal = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await getRealtimeUsers("runPageReport").then(
        (result) => {
          setActPC(result?.data);

          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const videoDetail = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getVCMS().then(
        (result) => {
          setEditing(result.data);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const allUpdates = async () => {
      // setLoading(true);
      /* eslint-disable no-unused-vars */

      const result = await updates(getAppId()).then(
        (result) => {
          setAUpdates(result);
          //  setLoading(false);
        },
        (error) => {
          // setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const mediaId = async (
      fyear,
      fmonth,
      fday,
      tyear,
      tmonth,
      tday,
      editing,
      cloudSecretV2,
      number,
      time
    ) => {
      try {
        const result = await analytics(
          fyear,
          fmonth,
          fday,
          tyear,
          tmonth,
          tday,
          editing,
          cloudSecretV2,
          number,
          time,
          oneMonth(),
          date(),
          search
        );
        setMedia(result.data ? result.data.rows : []);
      } catch (error) {
        console.error("Error fetching media analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    const deviceName = async () => {
      const result = await logInDetail().then(
        (result) => {
          console.log("login detail", result.data);
          setLog(result.data.per_device);
        },
        (error) => {}
      );
    };
    deviceName();
    videoDetail();

    if (
      fyear &&
      fmonth &&
      fday &&
      tyear &&
      tmonth &&
      tday &&
      editing.cloudKey &&
      editing.cloudSecretV2
    ) {
      mediaId(
        fyear,
        fmonth.slice(-2),
        fday.slice(-2),
        tyear,
        tmonth.slice(-2),
        tday.slice(-2),
        editing.cloudKey,
        editing.cloudSecretV2,
        number,
        time
      );
    }

    elementDetail();
    detail();
    allUpdates();
    pageDetail();
    RealTimeStats();
    ActiveUserCountry();
    ActiveUserTotal();
    ActivePageTotal();
    // eslint-disable-line react-hooks/exhaustive-deps
    //eslint-disable-next-line
  }, [
    fyear,
    fmonth,
    fday,
    tyear,
    tmonth,
    tday,
    editing.cloudKey,
    editing.cloudSecretV2,
    number,
    time,
    search,
  ]);

  function formatDate(string) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  function filterData(emp, filter) {
    const filtered = emp.filter((item) => {
      return item.dimensionValues[0].value === filter;
    });
    if (filtered.length > 0) {
      return filtered[0].metricValues[0].value;
    } else {
      return "0";
    }
  }

  function updateArray() {
    let arr = [];
    aUpdates.map((elem, index) =>
      elem.data.map((elem, index) =>
        // arr.length<5 &&
        arr.push(elem)
      )
    );
    arr.sort((a, b) => (a.editedDate > b.editedDate ? -1 : 1));
    return arr;
  }

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box background-2 text-white">
              {/* info-box-icon bg-info elevation-1 */}
              <span className="info-box-icon text-danger">
                <i className="fas fa-eye" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Real Time Views</span>
                <span className="info-box-number">
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "page_view") + " Views"
                    : "0 Views"}
                  <small />
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box mb-3 background-2 text-white">
              <span className="info-box-icon text-warning">
                <i className="fas fa-users" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Real Time Active Users</span>
                <span className="info-box-number">
                  {" "}
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "user_engagement") + " Users"
                    : "0 Users"}
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          {/* fix for small devices only */}
          <div className="clearfix hidden-md-up" />
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box mb-3 background-2 text-white">
              <span className="info-box-icon text-success">
                <i className="fas fa-map" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">First Time Visits</span>
                <span className="info-box-number">
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "first_visit") + " Visits"
                    : "0 Visits"}
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
          <div className="col-12 col-sm-6 col-md-3">
            <div className="info-box mb-3 background-2 text-white">
              <span className="info-box-icon text-info">
                <i className="fas fa-mouse-pointer" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">User Session Started</span>
                <span className="info-box-number">
                  {realStats.rowCount > 0
                    ? filterData(realStats.rows, "session_start") + " Sessions"
                    : "0 "}
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            {/* /.info-box */}
          </div>
          {/* /.col */}
        </div>

        <div className="row mb-2 mt-2"></div>

        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Recent Updates</h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div
                className="card-body"
                style={{ width: "100%", height: 300, overflowY: "auto" }}
              >
                {/* TODO:Fix the issue with null check for getDashBoardElements and getDashBoardPages response. */}

                {/* {updateArray().length===0&&
              <div className="center" style={{textAlign: 'center'}} >
              <Loader type="TailSpin" color="#ee3c2c" height={300} width={"10%"} />
            </div>
              } */}
                {updateArray().length > 0 &&
                  updateArray().map((item, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-between align-items-center border-bottom mb-3"
                    >
                      <p className="d-flex flex-column ">
                        <span className="font-weight-bold">
                          {/* <i className="fas fa-eye text-success"></i> */}{" "}
                          {item.referenceName.slice(0, 30)}
                          <br />
                          {item.referenceName.slice(30)}
                        </span>
                        <span className="text-muted">
                          {formatDate(item.editedDate)}
                        </span>
                      </p>
                      <p className="text-success text-xl text-right mr-4">
                        <i
                          className={
                            item.pageType
                              ? "fas fa-file text-success"
                              : "fas fa-plus-square text-success"
                          }
                        ></i>
                      </p>
                    </div>
                  ))}
                {updateArray().length > 0 &&
                  updateArray().map((item, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-between align-items-center border-bottom mb-3"
                    >
                      <p className="d-flex flex-column ">
                        <span className="font-weight-bold">
                          {/* <i className="fas fa-eye text-success"></i> */}{" "}
                          {item.referenceName.slice(0, 30)}
                          <br />
                          {item.referenceName.slice(30)}
                        </span>
                        <span className="text-muted">
                          {formatDate(item.editedDate)}
                        </span>
                      </p>
                      <p className="text-success text-xl text-right mr-4">
                        <i
                          className={
                            item.pageType
                              ? "fas fa-file text-success"
                              : "fas fa-plus-square text-success"
                          }
                        ></i>
                      </p>
                    </div>
                  ))}
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card background-2">
              <div className="card-header">
                <h3 className="card-title text-white">Device Based Users</h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body p-0">
                <CountryPie data={log}></CountryPie>
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
        </div>

        <div className="row mb-2 mt-2"></div>
        <div className="row mb-2 mt-2"></div>

        <div className="row">
          <div className="col-md-6">
            <div className="card background-2">
              <div className="card-header">
                <h3 className="card-title text-white">
                  JW Player Daily Summary
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body p-0">
                {/* <BarCharts info={media}></BarCharts> */}
                <BarCharts info={media}></BarCharts>
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="card background-2">
              <div className="card-header">
                <h3 className="card-title text-white">
                  Last 7 days User Engagement
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div className="card-body p-0">
                <LineCountry data={dAnalytics}></LineCountry>
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
        </div>

        <div className="row mb-2 mt-2"></div>

        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Active Users by Page in Last 30 days
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div
                className="card-body"
                style={{ width: "100%", height: 300, overflowY: "auto" }}
              >
                {actPC.length === 0 && (
                  <div className="center" style={{ textAlign: "center" }}>
                    <Loader
                      type="TailSpin"
                      color="#ee3c2c"
                      height={300}
                      width={"10%"}
                    />
                  </div>
                )}
                {actPC.length > 0 &&
                  actPC.map((row, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-between align-items-center border-bottom mb-3"
                    >
                      <p className="text-success text-xl">
                        <i className="fas fa-user"></i>
                      </p>
                      <p className="d-flex flex-column text-right">
                        <span className="font-weight-bold">
                          <i className="fas fa-eye text-success"></i>{" "}
                          {row.metricValues[0].value + " users"}
                        </span>
                        <span className="text-muted">
                          {row.dimensionValues[0].value}
                        </span>
                      </p>
                    </div>
                  ))}
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Total Users by Page in Last 30 days
                </h3>
                <div className="card-tools"></div>
              </div>
              {/* /.card-header */}
              <div
                className="card-body"
                style={{ width: "100%", height: 300, overflowY: "auto" }}
              >
                {actPC.length === 0 && (
                  <div className="center" style={{ textAlign: "center" }}>
                    <Loader
                      type="TailSpin"
                      color="#ee3c2c"
                      height={300}
                      width={"10%"}
                    />
                  </div>
                )}
                {actPC.length > 0 &&
                  actPC.map((row, index) => (
                    <div
                      key={index}
                      className="d-flex justify-content-between align-items-center border-bottom mb-3"
                    >
                      <p className="text-success text-xl">
                        <i className="fas fa-user"></i>
                      </p>
                      <p className="d-flex flex-column text-right">
                        <span className="font-weight-bold">
                          <i className="fas fa-eye text-success"></i>{" "}
                          {row.metricValues[1].value + " users"}
                        </span>
                        <span className="text-muted">
                          {row.dimensionValues[0].value}
                        </span>
                      </p>
                    </div>
                  ))}
              </div>
              {/* /.card-body */}

              {/* /.card-footer */}
            </div>
          </div>
        </div>

        <div className="row mb-2 mt-2"></div>

        <div className="row"></div>
      </div>
    </section>
  );
};

export default Home;
